'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['readAll']
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"project project--all\">\n    <div class=\"project__overlay project__overlay--image\" :style=\"{ 'background-image': 'url(' + readAll.image + ')' }\"></div>\n    <div class=\"project__overlay project__overlay--color\"></div>\n    <div class=\"project__overlay project__overlay--dotted\"></div>\n    <div class=\"project__caption project__caption--link\">\n        <button class=\"button button--blue\">{{ readAll.text }}</button>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6936acb2", module.exports)
  } else {
    hotAPI.update("_v-6936acb2", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}